import { TableContainer, Table, TableProps, Paper } from "@mui/material";

export default function StickyTable(props: TableProps) {
  return (
    // To make StickyTable table sticky add a max height to the Container
    <TableContainer component={Paper}>
      <Table stickyHeader {...props}>
        {props.children}
      </Table>
    </TableContainer>
  );
}
